export default "__VITE_ASSET__sb_joump__"